import { render } from "./billerList.vue?vue&type=template&id=6f20590f&scoped=true"
import script from "./billerList.vue?vue&type=script&lang=js"
export * from "./billerList.vue?vue&type=script&lang=js"

import "./billerList.vue?vue&type=style&index=0&id=6f20590f&scoped=true&lang=css"

import exportComponent from "C:\\WSS-BuildAgent\\_work\\5\\s\\Sureload Admin\\sureload-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f20590f"]])

export default __exports__